module.exports = __webpack_public_path__ + "static/media/delivery.ecce7f99.svg";